import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { style: {"clip-path":"inset(0 100% 0 0)","height":"0"} }

import {
  Citizen,
  IdentityCard,
  getIdentityCardStatus,
  IdentityCardsService,
  CitizenDocumentInfo,
  User,
  ConsumptionRatesService,
  ConsumptionStandardsService,
  ProductCategory,
  PrintableDataForIdentityCard,
  Id,
  CardIssuePointsService,
  UuidIdGenerator,
  ConfirmableDataForIdentityCard,
  MunicipalEntitiesService,
  MunicipalEntity,
  CardIssuePoint,
} from '@prodcard/core'
import CitizenCardPdf from './CitizenCardPdf.vue'
import IdentityCardComponent, { CardWithStatus } from './IdentityCard.vue'
import { createCtx, handleError } from '../../../../helpers'
import { renderComponent } from '../../../../common'
import { ref, Ref, getCurrentInstance } from 'vue'
import { jsPDF } from 'jspdf'
import { toJpeg } from 'html-to-image'
import { pickBy } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizenCardsTab',
  props: {
    cardIssuePointsService: {},
    municipalEntitiesService: {},
    identityCardsService: {},
    citizen: {},
    currentUser: {},
    citizenDocumentInfo: {},
    municipalEntity: {},
    consumptionRatesService: {},
    consumptionStandardsService: {}
  },
  setup(__props: any) {

const props = __props;

const currentInstance = getCurrentInstance()
let destroyComp: () => void | undefined



const idGenerator = new UuidIdGenerator()

const identityCards: Ref<CardWithStatus[]> = ref([])
const loading = ref(false)
const loadingCardId = ref<Id | undefined>(undefined)
const disabledCards = ref(false)

const pdfHtml = ref()
const showPdfDialog = ref(false)
const pdfLink = ref<URL | undefined>(undefined)

handleError(async () => {
  const resp = await props.identityCardsService.findCitizenCards(createCtx(), props.citizen.id)
  identityCards.value = resp.map(s => {
    return { ...s, status: getIdentityCardStatus(s), id: s.id || idGenerator.generate() }
  })
}, loading)

const serializeCard = (card: CardWithStatus) => {
  return pickBy(card, (val, key) => {
    return !['createdAt', 'id', 'status', 'confirmedAt'].includes(key)
  })
}

const updateCardList = (card: IdentityCard) => {
  identityCards.value = identityCards.value.map(c => {
    if (card.id !== c.id) return c

    return { ...card, status: getIdentityCardStatus(card) }
  })
}

const updateAndPrintCard = (card: CardWithStatus) => {
  handleError(async () => {
    const ctx = createCtx()

    try {
      const consumptionRates = await props.consumptionRatesService.get(ctx)
      const consumptionStandards = await props.consumptionStandardsService.get(ctx)
      const prodInfos = Object.entries(consumptionRates).map(entry => {
        return {
          category: ProductCategory[entry[0] as ProductCategory],
          amount: entry[1].couponsCountPerMonth,
          standard: `${consumptionStandards[props.citizen.category][entry[0] as ProductCategory]}`,
        }
      })

      loadingCardId.value = card.id
      const realCard = await props.identityCardsService.print(ctx, serializeCard(card) as PrintableDataForIdentityCard)
      let cardIssuePoint: CardIssuePoint | undefined

      const currentCipId = realCard.cardIssuePointId || props.currentUser?.cardIssuePointId
      if (currentCipId) {
        cardIssuePoint = await props.cardIssuePointsService.findById(ctx, currentCipId)
      }

      destroyComp?.()
      destroyComp = renderComponent(
        pdfHtml.value,
        CitizenCardPdf,
        {
          citizen: props.citizen,
          currentUser: props.currentUser,
          citizenDocumentInfo: props.citizenDocumentInfo,
          identityCard: realCard,
          municipalEntity: props.municipalEntity,
          cardIssuePoint,
          prodInfos,
        },
        currentInstance?.appContext,
      )
      updateCardList({ ...realCard, id: card.id })

      const doc = new jsPDF({
        orientation: 'landscape',
      })
      const img = await toJpeg(pdfHtml.value, { width: 3284, height: 2244, backgroundColor: '#ffffff', quality: 1 })

      // цифры в миллиметрах, размер а4 210x297мм
      doc.addImage(img, 'JPEG', 9.5, 10, 278, 190)

      pdfLink.value = doc.output('bloburi')
      showPdfDialog.value = true
    } finally {
      loadingCardId.value = undefined
    }
  }, disabledCards)
}

const confirmCard = (card: CardWithStatus) => {
  handleError(async () => {
    try {
      loadingCardId.value = card.id
      const realCard = await props.identityCardsService.confirm(
        createCtx(),
        serializeCard(card) as ConfirmableDataForIdentityCard,
      )
      updateCardList({ ...realCard, id: card.id })
    } finally {
      loadingCardId.value = undefined
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 0,
          class: "ml-1"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(identityCards.value, (card) => {
              return (_openBlock(), _createBlock(IdentityCardComponent, {
                "card-issue-points-service": _ctx.cardIssuePointsService,
                "municipal-entities-service": _ctx.municipalEntitiesService,
                "municipal-entity-id": _ctx.citizen.municipalEntityId,
                "current-user": _ctx.currentUser,
                key: card.id,
                card: card,
                loading: loadingCardId.value === card.id,
                disabled: disabledCards.value,
                "onClick:print": updateAndPrintCard,
                "onClick:confirm": confirmCard
              }, null, 8, ["card-issue-points-service", "municipal-entities-service", "municipal-entity-id", "current-user", "card", "loading", "disabled"]))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 1,
          width: "500",
          type: "heading, subtitle, actions, heading, subtitle, actions"
        })),
    _createVNode(_component_v_dialog, {
      modelValue: showPdfDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showPdfDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          height: "2000",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showPdfDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Закрыть")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (pdfLink.value)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  style: {"font-family":"PTSans"},
                  src: pdfLink.value.toString(),
                  height: "100%",
                  width: "100%"
                }, null, 8, _hoisted_1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "pdfHtml",
        ref: pdfHtml,
        style: {"font-family":"'PTSans'"}
      }, null, 512)
    ])
  ], 64))
}
}

})